<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'>数据分析</i></el-breadcrumb-item>
                <el-breadcrumb-item>埋点数据</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='项目'>
                                <el-select @change='handleSelectProject' clearable size='mini' v-model='queryParams.projectAppId' filterable placeholder='请选择'>
                                    <el-option
                                        v-for='item in projectInfoList'
                                        :key='item.appId'
                                        :label='item.cnName'
                                        :value='item.appId'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='事件'>
                                <el-select clearable size='mini' v-model='queryParams.eventId' filterable placeholder='请选择'>
                                    <el-option
                                        v-for='item in trackEventList'
                                        :key='item.id'
                                        :label='`${item.eventId} ${item.eventName}`'
                                        :value='item.id'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                                <el-button icon='el-icon-upload2' size='mini' type='primary' @click='handleOpenExport'>
                                    导出
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-statistic value-style='font-weight: bold' :value="queryParams.total" title="事件数">
                            <template slot="prefix">
                              <span class="like">
                                <i
                                    class="el-icon-s-flag"
                                    style="color: #409EFF"
                                ></i>
                              </span>
                            </template>
                        </el-statistic>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-if='queryParams.projectAppId && queryParams.eventId' v-loading='loading'
                      :cell-style="{ textAlign: 'center' }" :data='trackDataList'
                      @sort-change='handleSortChange'>
                <el-table-column label='事件ID' align='center'>
                    <template slot-scope='scope'>
                        <span>{{ computeEventName(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label='客户端ID' align='center'>
                    <template slot-scope='scope'>
                        <span>{{ scope.row.clientTag }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label='事件数据' align='center'>
                    <template slot-scope='scope'>
                        <span>{{ scope.row.value }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label='查看事件数据' align='center'>
                    <template slot-scope='scope'>
                        <el-button type='text' @click='handleViewTrackParameterInfo(scope.row)'>查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label='其他数据' align='center'>
                    <template slot-scope='scope'>
                        <span>{{ scope.row.otherData }}</span>
                    </template>
                </el-table-column>
                <el-table-column width='200' sortable='custom' label='创建时间' align='center' prop='createTime' />
            </el-table>
            <div v-else>
                <el-alert
                    title='埋点数据量比较多, 为了提升查询速度, 请指定项目名和事件'
                    :closable='false'
                    type='success'>
                </el-alert>
            </div>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='sizes, prev, pager, next'
                    @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改用户配置对话框 -->
            <el-dialog :title='title' :visible.sync='open' width='40%' append-to-body>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
            
            <el-dialog title='事件详细数据' :visible.sync='openTrackDataParam' width='40%' append-to-body>
                <vue-json-pretty :data='showCurrentTrackData' />
            </el-dialog>
            
            <el-dialog title='导出数据配置' :visible.sync='openExportTrackData' width='40%' append-to-body>
                <el-form ref='queryForm1' size='small'>
                    <el-form-item label='选择项目'>
                        <el-select multiple clearable size='mini' v-model='exportTrackConfig.projectAppIdList'
                                   filterable placeholder='请选择' @change='handleProjectAppIdChange'>
                            <el-option
                                v-for='item in projectInfoList'
                                :key='item.appId'
                                :label='item.cnName'
                                :value='item.appId'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='事件'>
                        <el-select clearable multiple size='mini' v-model='exportTrackConfig.eventIdList'
                                   filterable placeholder='请选择' @change='handleEventChange'>
                            <el-option
                                v-for='item in exportEventOptions'
                                :key='item.id'
                                :label='`${item.eventId} ${item.eventName}`'
                                :value='item.id'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='导出格式'>
                        <el-select size='mini' v-model='exportTrackConfig.format'
                                   placeholder='请选择导出格式 默认CSV'>
                            <el-option
                                v-for='item in exportFormatOptions'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='合并事件'
                                  v-if='exportTrackConfig.eventIdList && exportTrackConfig.eventIdList.length > 1'>
                        <el-switch
                            v-model='exportTrackConfig.mergeEventData'
                            active-text='合并'
                            inactive-text='不合并'>
                        </el-switch>
                    </el-form-item>
                    <el-form-item label='移除事件中的空字段'
                                  v-if='exportTrackConfig.format && exportTrackConfig.format === "JSON"'>
                        <el-switch
                            v-model='exportTrackConfig.removeEmptyField'
                            active-text='移除'
                            inactive-text='不移除'>
                        </el-switch>
                    </el-form-item>
                    <el-form-item label='导出字段'>
                        <el-select size='mini' v-model='exportTrackConfig.includeFieldList' multiple clearable
                                   filterable
                                   placeholder='请选择需要导出的字段, 默认导出所有字段'>
                            <el-option
                                v-for='item in exportIncludeFieldOptions'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='时间'>
                        <el-date-picker
                            size=''
                            v-model='timePicker.pickerTimeValue'
                            type='datetimerange'
                            align='right'
                            unlink-panels
                            range-separator='至'
                            start-placeholder='开始日期'
                            end-placeholder='结束日期'
                            value-format='yyyy-MM-dd HH:mm:ss'
                            @blur='handleTimePickerBlur'
                            :picker-options='timePicker.pickerOptions'>
                        </el-date-picker>
                    </el-form-item>
                    
                    <el-form-item label='条件过滤' v-if='exportTrackConfig.eventIdList.length === 1'>
                        <track-data-filter @getFilterCondition='handleGetFilterCondition'
                                           :event-id='exportTrackConfig.eventIdList[0]' :condition-config='{}' />
                    </el-form-item>
                    
                    <el-form-item style='margin-bottom: 0;'>
                        <el-button icon='el-icon-search' size='mini' type='primary' @click='createExportTask'>执 行
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { message } from '@/utils/message';
import { trackDataApi } from '@api/Track/trackData';
import { trackEventApi } from '@api/Track/trackEvent';
import { projectInfoApi } from '@api/ProjectInfo';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import { deepCopy } from '@/utils/object';
import TrackDataFilter from '@/components/component/storage/TrackDataFilter.vue';
import { exportTrackDataApi } from '@api/Track/exportTrackData';
import { notification } from '@/utils/notification';
import { trackParameterApi } from '@api/Track/trackParameter';

export default {
    name: 'User',
    components: {
        TrackDataFilter,
        VueJsonPretty
    },
    data() {
        return {
            // 遮罩层
            loading: false,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                
                projectAppId: undefined,
                deduplicationStrategy: undefined,
                eventId: undefined,
                eventName: undefined
            },
            
            trackDataList: [],
            trackEventList: [],
            currentTrackData: {},
            eventMap: new Map,
            mapTrackerNum: 1,
            projectInfoList: [],
            openTrackDataParam: false,
            currentViewTrackData: {
                jsonTextObject: undefined
            },
            showCurrentTrackData: {},
            
            openExportTrackData: false,
            exportTrackConfig: {
                pickerTimeValue: [],
                eventIdList: [],
                projectAppIdList: [],
                startTime: undefined,
                endTime: undefined,
                multiConditionExpress: {}
            },
            timePicker: {
                pickerTimeValue: [],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近五个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                }
            },
            exportFormatOptions: [
                {
                    label: 'CSV',
                    value: 'CSV'
                },
                {
                    label: 'JSON',
                    value: 'JSON'
                }
            ],
            exportEventOptions: [],
            exportIncludeFieldOptions: []
        };
    },
    computed: {
        computeEventName() {
            return (data) => {
                let event = this.eventMap.get(parseInt(data.eventId));
                if (!event) {
                    return '未知';
                } else {
                    return event.eventName;
                }
            };
        },
        computeUserAccount() {
            return (data) => {
                // let user = this.adminUserMap.get(data.createUserId)
                // if (!user) {
                //     return '未知'
                // }else {
                //     return user.nickName
                // }
            };
        }
    },
    created() {
        // this.getList();
        this.initData();
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        initData() {
            this.eventMap = new Map;
            this.trackEventList = [];
            this.projectInfoList = [];
            this.queryTrackEventList(undefined)
            projectInfoApi.query({ pageSize: 10000 }).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result;
                }
            });
        },
        getList() {
            this.loading = true;
            trackDataApi.query(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.trackDataList = result.data.result;
                    
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize;
                }
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            if (!this.queryParams.eventId || !this.queryParams.projectAppId) {
                message.error('为了提升查询速度 请指定查询项目和事件');
                return;
            }
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'id desc'
                ]
            };
            this.queryTrackEventList(undefined)
            // this.handleQuery()
            this.trackDataList = [];
        },
        resetQueryPage() {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '分配分组';
            this.updateStatus = false;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentDataInfo = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件信息';
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this;
            this.$modal.confirm('是否确认删除"' + row.eventName + '"的数据项？').then(function() {
                return;
            }).then((result) => {
                if (result.code === 200) {
                    obj.getList();
                    message.success(result.message);
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
        
        },
        handleViewTrackParameterInfo(row) {
            this.currentViewTrackData = deepCopy(row);
            this.currentViewTrackData.jsonTextObject = JSON.parse(this.currentViewTrackData.value);
            this.openTrackDataParam = true;
            this.showCurrentTrackData = deepCopy(row);
            try {
                let otherData = JSON.parse(this.showCurrentTrackData.otherData);
                let value = JSON.parse(this.showCurrentTrackData.value);
                delete this.showCurrentTrackData.otherData;
                delete this.showCurrentTrackData.value;
                this.showCurrentTrackData.otherData = otherData;
                this.showCurrentTrackData.value = value;
            } catch (e) {
            
            }
        },
        queryTrackEventList(projectAppId) {
            trackEventApi.queryTrackEvent({ pageSize: 1000000, projectAppId: projectAppId }).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result;
                    result.data.result.forEach(t => {
                        this.eventMap.set(parseInt(t.id), t);
                        this.mapTrackerNum = this.mapTrackerNum + 1;
                    });
                }
            });
        },
        handleSelectProject(projectAppId) {
            if (projectAppId) {
                this.queryTrackEventList(projectAppId);
            } else {
                this.queryTrackEventList(undefined);
            }
        },
        handleTimePickerBlur() {
            if (this.timePicker.pickerTimeValue.length === 0) {
                return;
            }
            this.exportTrackConfig.startTime = this.timePicker.pickerTimeValue[0];
            this.exportTrackConfig.endTime = this.timePicker.pickerTimeValue[1];
        },
        handleGetFilterCondition(condition) {
            this.exportTrackConfig.multiConditionExpress = condition;
        },
        createExportTask() {
            if (this.exportTrackConfig.eventIdList.length === 0) {
                message.error('必须选择埋点事件!');
                return;
            }
            if (this.exportTrackConfig.eventIdList.length >= 2) {
                this.exportTrackConfig.multiConditionExpress = undefined;
            }
            exportTrackDataApi.createExportTask(this.exportTrackConfig).then(result => {
                if (result.code === 200) {
                    message.success('任务创建成功!');
                    this.openExportTrackData = false;
                    
                    let url = window.location.protocol + '//' + window.location.host + '/#/exportTask';
                    let notificationMessage = `任务详情请到 <a href='${url}' target='_blank'>${url}</a> 查看`;
                    notification.success(notificationMessage);
                }
            });
        },
        handleOpenExport() {
            this.exportTrackConfig = {
                pickerTimeValue: [],
                eventIdList: [],
                projectAppIdList: [],
                startTime: undefined,
                endTime: undefined,
                multiConditionExpress: {}
            };
            this.timePicker.pickerTimeValue = [];
            this.openExportTrackData = true;
        },
        handleEventChange(eventIdList) {
            this.exportIncludeFieldOptions = [];
            if (!eventIdList || eventIdList.length === 0) {
                return;
            }
            
            this.exportIncludeFieldOptions = [
                {
                    label: '上报时间',
                    value: 'createDate'
                },
                {
                    label: '玩家唯一id',
                    value: 'clientTag'
                },
                {
                    label: '操作系统名字',
                    value: 'OperationSystemName'
                },
                {
                    label: '操作系统版本',
                    value: 'OperationSystemVersion'
                },
                {
                    label: '国家',
                    value: 'RequestAddressIPCountry'
                },
                {
                    label: '省份',
                    value: 'RequestAddressProvince'
                },
                {
                    label: '市级市',
                    value: 'RequestAddressCity'
                }
            ];
            this.exportTrackConfig.eventIdList.map(async eventId => {
                let event = this.eventMap.get(parseInt(eventId));
                let result = await trackParameterApi.queryTrackParameter({ eventId: eventId });
                if (result.code === 200 && result.data.result) {
                    result.data.result.forEach(item => {
                        this.exportIncludeFieldOptions.push({
                            label: `${item.description || item.name}(${event.eventName || event.eventId})`,
                            value: `${event.eventId}_${item.name}`
                        });
                    });
                }
            });
            
        },
        handleProjectAppIdChange(appIdList) {
            this.exportEventOptions = [];
            if (!appIdList) {
                return;
            }
            
            this.exportTrackConfig.projectAppIdList.map(async appId => {
                trackEventApi.queryTrackEvent({ pageSize: 1000000, projectAppId: appId }).then(result => {
                    if (result.code === 200) {
                        result.data.result.forEach(t => {
                            if (!this.exportEventOptions.find(item => item.id === t.id)) {
                                this.exportEventOptions.push(t);
                            }
                        });
                    }
                });
            });
        }
    }
};
</script>
